import { render, staticRenderFns } from "./TagTableAllType.vue?vue&type=template&id=723c6884&scoped=true"
import script from "./TagTableAllType.vue?vue&type=script&lang=js"
export * from "./TagTableAllType.vue?vue&type=script&lang=js"
import style0 from "./TagTableAllType.vue?vue&type=style&index=0&id=723c6884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723c6884",
  null
  
)

export default component.exports